import _ from 'lodash';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {
    SHOW_NOT_RESULT_SEARCH_HEADER,
    RESET_HEADER_SEARCH_TOOLTIP,
    SET_HEADER_SEARCH_LOADER,
    SET_QUERY_SEARCH
} from '@/store/mutation-types';
import {
    GET_HEADER_SEARCH_TOOLTIP,
    GET_SEARCH_LIST
} from '@/store/action-types';

export default {
    name: 'header-search',
    data() {
        return {
            show: false
        }
    },
    computed: {
        ...mapGetters({
            querySearch: 'search/querySearch',
            resultSearch: 'search/resultHeaderSearch',
            searchLoader: 'search/headerSearchLoader',
            noResultSearchHeader: 'search/noResultSearchHeader',
        })
    },
    methods: {
        ...mapActions({
            fetchSearchTooltip: `search/${GET_HEADER_SEARCH_TOOLTIP}`,
            fetchSearch: `search/${GET_SEARCH_LIST}`
        }),
        ...mapMutations({
            reset: `search/${RESET_HEADER_SEARCH_TOOLTIP}`,
            setQuerySearch: `search/${SET_QUERY_SEARCH}`,
            changeNoResultSearch: `search/${SHOW_NOT_RESULT_SEARCH_HEADER}`,
            changeLoader: `search/${SET_HEADER_SEARCH_LOADER}`,
        }),
        sendRequest: _.debounce(function () {
            if (this.querySearch.length > 2) {
                this.fetchSearchTooltip(this.querySearch);
            }
        }, 500),
        changeSearch(query) {
            this.setQuerySearch(query);
            this.changeLoader(true);
            this.changeNoResultSearch(false);
            this.reset();
            this.sendRequest();
        },
        goResultSearch(params) {
            this.setQuerySearch(params);
            if(this.$route.query.search !== this.querySearch){
                this.setQuerySearch(params);
                this.$router.push({name: 'search-result', query: {'search': params}});
                this.reset();
                this.fetchSearch();
            }
        },
        setFocusField(status){
            setTimeout(() => {
                this.show = status;
            }, 300);
        }
    }
}
